import { IDataLayerEvent } from '@agco-onedigital/ecosystem-lib-frontend-utils';

export const fireCustomEvent = (dataLayerEvent: IDataLayerEvent) => {
  window?.dataLayer?.push(dataLayerEvent);
};
